import { LsqLoadingModalComponent } from '../components/modals/lsq-loading-modal.component';
import { Modal } from '../models/common';

export class LsqLoadingModal extends Modal {
    public id = 'lsq-loading-modal';
    public width = '58.7rem';
    public showCloseButton = false;
    public component = LsqLoadingModalComponent;
    public showFooter = false;
    public showOkButton = false;
    public showCancelButton = false;
    public clickOutsideToClose = false;

    constructor(title: string, subtitle?: string) {
        super({
            title,
            data: {
                title,
                subtitle
            }
        });
    }
}
